

import Vue from 'vue';

/*
* v-clickout - Vue directive to close a tooltip when the user clicks outside of it on tablet
*/
Vue.directive(`clickout`, {
  bind (el, binding, vnode) {
    el.clickOutsideEvent = event => {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener(`click`, el.clickOutsideEvent);
  },
  unbind (el) {
    document.body.removeEventListener(`click`, el.clickOutsideEvent);
  },
});

export default {
  props: {
    player: {
      type: Object,
      required: true,
    },
    team: {
      type: Object,
      required: true,
    },
    side: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      active: false,
      type: `player`,
      clicked: false,
    };
  },
  computed: {
    stats () {
      return [];
    },
    events () {
      return [];
    },
  },
  methods: {
    openTooltip (type) {
      this.type = type;
      this.active = true;
    },
    openMobileTooltip () {
      // Open on mobile
      this.clicked = true;
    },
    closeMobileTooltip () {
      this.clicked = false;
    },
  },
};
